import $ from 'jquery'

$(document).on('click', '#filter-btn', function () {
  $('#filter-box').removeClass('hidden')
})

$(document).on('click', '#filter-btn-close', function () {
  $('#filter-box').addClass('hidden')
})

let isEnterExpanded = false
$(document).on('click', '#select-enter-door', function () {
  isEnterExpanded = !isEnterExpanded
  $(this).find('svg').toggleClass('rotate-90')
  $('#enter-door-nav').toggleClass('hidden')
})

let initCalled = false
function init() {
  if (initCalled) return
  initCalled = true

  window.addEventListener('popstate', function () {
    const queryString = new URLSearchParams(window.location.search).toString()
    const url = `/vchodove-dvere/?${queryString}`
    jQueryRefresh(url)
  })
}

window.onFormChange = function (event) {
  init()
  const queryString = new URLSearchParams(new FormData(event.currentTarget)).toString()
  const url = `/vchodove-dvere/?${queryString}`
  const isVisible = !$('#filter-box').hasClass('hidden')
  jQueryRefresh(url, function () {
    if (isVisible) {
      $('#filter-box').removeClass('hidden')
    }
  })
  window.history.pushState(undefined, '', url)
  event.preventDefault()
}

function jQueryRefresh(url, callback) {
  $.get(url).then(text => {
    const html = $(text)

    $('#page').replaceWith(html.filter('#page'))

    updateFavoritesCount()
    activateFavoritesIcons()

    if (isEnterExpanded) {
      $('#select-enter-door svg').addClass('rotate-90')
      $('#enter-door-nav').removeClass('hidden')
    }

    document.title = html.filter('title').text()
    document.getElementById('page').scrollIntoView({ block: 'start', behaviour: 'smooth ' })
    callback && callback()
  })
}

// === OBLÍBENÉ ===

// Aktualizace počtu oblíbených
function updateFavoritesCount() {
  const favorites = localStorage.getItem('favorites')
    ? JSON.parse(localStorage.getItem('favorites'))
    : []
  const favoritesCount = document.getElementById('favorites-count')
  if (favoritesCount) {
    favoritesCount.textContent = favorites.length
    favoritesCount.style.opacity = favorites.length > 0 ? '1' : '0'
  }
}

// Aktivace ikon a klikání na oblíbené
function activateFavoritesIcons() {
  document.querySelectorAll('.add-to-favorites').forEach(function (btn) {
    const doorContainer = btn.closest('[data-door-id]')
    if (!doorContainer) return

    const doorId = doorContainer.getAttribute('data-door-id')
    const svetlik = doorContainer.getAttribute('data-svetlik') || 'ne'
    const icon = btn.querySelector('img')

    const favorites = localStorage.getItem('favorites')
      ? JSON.parse(localStorage.getItem('favorites'))
      : []

    const exists = favorites.some(fav => fav.model === doorId && fav.svetlik === svetlik)

    if (icon) {
      const basePath = icon.src.substring(0, icon.src.lastIndexOf('/') + 1)
      icon.src = basePath + (exists ? "like-btn-activ.svg" : "like-btn.svg")
    }
  })

  const doorbox = document.getElementById('doorbox')
  if (doorbox && !doorbox.dataset.listenerAttached) {
    doorbox.addEventListener('click', function (e) {
      const btn = e.target.closest('.add-to-favorites')
      if (!btn) return

      const doorContainer = btn.closest('[data-door-id]')
      if (!doorContainer) return

      const doorId = doorContainer.getAttribute('data-door-id')
      const svetlik = doorContainer.getAttribute('data-svetlik') || 'ne'
      const icon = btn.querySelector('img')

      let favorites = localStorage.getItem('favorites')
        ? JSON.parse(localStorage.getItem('favorites'))
        : []

      const exists = favorites.some(fav => fav.model === doorId && fav.svetlik === svetlik)

      if (!exists) {
        favorites.push({ model: doorId, svetlik })
        if (icon) {
          const basePath = icon.src.substring(0, icon.src.lastIndexOf('/') + 1)
          icon.src = basePath + "like-btn-activ.svg"
        }
      } else {
        favorites = favorites.filter(fav => !(fav.model === doorId && fav.svetlik === svetlik))
        if (icon) {
          const basePath = icon.src.substring(0, icon.src.lastIndexOf('/') + 1)
          icon.src = basePath + "like-btn.svg"
        }
      }

      localStorage.setItem('favorites', JSON.stringify(favorites))
      updateFavoritesCount()
    })

    // Označit, že listener už je navázaný
    doorbox.dataset.listenerAttached = 'true'
  }
}

// === Inicializace ===

document.addEventListener('DOMContentLoaded', function () {
  updateFavoritesCount()
  activateFavoritesIcons()
})